
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const PlayAudioModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class PlayAudioModal extends PlayAudioModalProps {
  @Prop({ required: false })readonly audioFilePath: string
  // @Prop(Boolean) close: boolean | false
  data () {
    return {
      isLoading: false,
      filePath: '',
      isPlaying: false,
      currentTimeMillis: 0,
      maxDuration: 120000
    }
  }

  get isComponentModalActive () {
    if (this.close) {
      setTimeout(() => { if (this.audioElement) { this.play() } }, 1000)
    }
    return this.close
  }

  created () {
    this.$multiwatch(['audioFilePath'], function () {
      this.loadAudioFile(this.audioFilePath)
    })
  }

  mounted () {
    this.loadAudioFile(this.audioFilePath)
  }

  setCurrentTimeTimeout () {
    this.currentTimeInterval = setInterval(this.updateCurrentTime, 1000)
  }

  updateCurrentTime () {
    this.currentTimeMillis += 1000
  }

  updatePlayerTime () {
    this.currentTimeMillis = Math.floor(this.audioElement.currentTime) * 1000
  }

  updatePlayerDuration () {
    this.maxDuration = Math.floor(this.audioElement.duration) * 1000
  }

  formatSecs (val) {
    var d = Math.abs(val) / 60000
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    var timerMins = mins === 0 ? '' : mins < 10 ? `0${mins}` : mins
    var timerSecs = secs < 10 ? `0${secs}` : secs
    return `${timerMins}${timerMins === '' ? '' : ':'}${timerSecs}`
  }

  pause () {
    if (this.audioElement) {
      this.isPlaying = false
      this.audioElement.pause()
    } else {
      this.isRecording = false
      clearInterval(this.currentTimeInterval)
      this.stopRecordAudio()
      setTimeout(() => { this.mergeAudioFiles() }, 1000)
    }
  }

  play () {
    this.isPlaying = true
    this.audioElement.play()
  }

  playEnded () {
    this.pause()
  }

  closeModal () {
    this.$emit('close')
    this.pause()
  }

  async loadAudioFile (filePath) {
    this.filePath = filePath
    if (this.audioElement) {
      this.audioElement.removeEventListener('ended', this.pause)
      this.audioElement.removeEventListener('timeupdate', this.updatePlayerTime)
      this.audioElement.removeEventListener('durationchange', this.updatePlayerDuration)
    }
    if (this.filePath) {
      this.disabled = false
      this.audioUrl = encodeURI(`${process.env.VUE_APP_SERVERURL}/media/${this.filePath}?cb=${new Date().getTime()}`)
      const blob = await FetchWrapper.getBlob(this.audioUrl)
      const blobUrl = URL.createObjectURL(blob)
      this.audioElement = new Audio(blobUrl)
      this.audioElement.addEventListener('ended', this.pause)
      this.audioElement.addEventListener('timeupdate', this.updatePlayerTime)
      this.audioElement.addEventListener('durationchange', this.updatePlayerDuration)
      this.audioElement.load()
    } else {
      this.disabled = true
      this.audioUrl = null
      this.audioElement = null
      this.maxDuration = 120000
    }
  }
}
